export default "__VITE_ASSET__1f6f3fc5__"